<template>
  <RCard>
    <div class="text-subtitle-1 text-secondary-2">Summary</div>

    <slot name="content">
      <div class="text-body-1 text-secondary-1 q-mt-md">{{ data }}</div>
    </slot>
  </RCard>
</template>

<script>
export default {
  name: 'TabSummary',
  props: {
    data: String
  }
}
</script>
